import { getCharmap, DEFAULT_FREQUENTLY_USED_CHARS, FREQUENTLY_USED_LIMIT, CurrencyCodeMap } from '../constants/charmap';
let Charmap;

// Returns an object with a key of "searchResults" (the category name)
// and value of an array of character items having the [term] substring
export const getFilteredCharmap = term => {
  if (!Charmap) {
    Charmap = getCharmap();
  }
  if (!term) return Charmap;
  const filteredCharacters = [];
  Object.values(Charmap).forEach(category => {
    category.forEach(character => {
      if (character.label.indexOf(term) >= 0) {
        filteredCharacters.push(character);
      }
    });
  });
  return {
    searchResults: filteredCharacters
  };
};
let frequently; // Cache the object so we don't fetch from localStorage every call

// Used the cached {frequently} used map or fetch from localStorage on first
// call, then return a charmap of the most frequently used chars
export const getFrequentlyUsed = getter => {
  if (!getter) return {};
  if (!Charmap) {
    Charmap = getCharmap();
  }

  // Expects object with charCode keys and count number values
  frequently = getter('frequently') || DEFAULT_FREQUENTLY_USED_CHARS;
  const currencyCode = getter('currency');
  const currencyCharCode = currencyCode && CurrencyCodeMap[currencyCode] && CurrencyCodeMap[currencyCode].toString();

  // Array of charCodes as strings
  const sortedCharCodes = Object.keys(frequently).sort((a, b) => {
    return frequently[b] - frequently[a];
  }).slice(0, FREQUENTLY_USED_LIMIT).filter(charCode => charCode !== currencyCharCode);

  // Add the portal's currency symbol to the beginning of the list
  if (currencyCharCode) {
    sortedCharCodes.unshift(currencyCharCode);
    if (sortedCharCodes.length > FREQUENTLY_USED_LIMIT) sortedCharCodes.pop();
  }
  const num = getter('last');
  const last = num && (typeof num === 'string' ? num : num.toString());

  // Add last used character to the end of the list if not present
  if (last && sortedCharCodes.indexOf(last) < 0) {
    sortedCharCodes[sortedCharCodes.length - 1] = last;
  }
  const frequentUsedCharacters = new Array(sortedCharCodes.length);
  Object.values(Charmap).forEach(category => {
    category.forEach(character => {
      const idx = sortedCharCodes.indexOf(character.charCode.toString());
      if (idx >= 0) {
        frequentUsedCharacters[idx] = character;
      }
    });
  });
  return {
    frequentlyUsed: frequentUsedCharacters
  };
};

// Update the {frequently} used map, last used char, and
// sync with the storage handlers
export const setFrequentlyUsed = (setter, charCode) => {
  if (!setter || !frequently) return;
  const count = frequently[charCode] || 0;
  frequently[charCode] = count + 1;
  setter('last', charCode);
  setter('frequently', frequently);
};